import { Select } from '@storeblocks/select';
import { setHours } from 'date-fns';
import { ChangeEvent, ComponentProps, useMemo } from 'react';

type HourPickerProps = {
  value: Date | null;
  onChange: (value: Date) => void;
  hint?: string;
} & Omit<ComponentProps<typeof Select>, 'value' | 'onChange' | 'options'>;

export const HourPicker = ({
  value,
  onChange,
  hint,
  ...props
}: HourPickerProps) => {
  const hours = useMemo(
    () =>
      Array(24)
        .fill(0)
        .map((_, i) => i)
        .map(hour => {
          const hourLabel = hour < 10 ? `0${hour}` : hour;
          return {
            label: `${hourLabel}:00`,
            value: hour.toString()
          };
        }),
    []
  );

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(setHours(value || new Date(), +e.target.value));
  };

  const hourValue = value == null ? '' : value.getHours().toString();

  return (
    <Select
      {...props}
      options={hours}
      onChange={handleChange}
      value={hourValue}
      hint={hint}
      small
    />
  );
};
